import { type SezioneDTO } from '@framework/api-client/api/inquiries/schemas/sezioneDTO.ts';
import { type IRootWidgetIdentifier } from '@framework/engine/tree/references/TreeReferencesGlobalContext.tsx';
import { getAllRoots } from '@framework/engine/tree/references/utils/getAllRoots.ts';
import { useMemo } from 'react';

function typedGetAllRoot(
  allSections: SezioneDTO[] | null | undefined,
): IRootWidgetIdentifier[] {
  return getAllRoots(allSections);
}

export function useFillableAllRoots(
  allSections: SezioneDTO[] | null | undefined,
): IRootWidgetIdentifier[] {
  const allRoots: IRootWidgetIdentifier[] = useMemo(
    () => typedGetAllRoot(allSections),
    [allSections],
  );

  return allRoots;
}
